import {NavLink} from 'react-router-dom';
import {useAuth} from '../../context/AuthContext';
import {Button} from 'react-bootstrap';
import apiClient from '../../api/apiClient';
import {useAlert} from '../../context/AlertContext';
import Classes from './UserSidebarMenu.module.scss';

//== Icons
import accIcon from '../../assets/icons/user.svg';
import channelIcon from '../../assets/icons/settings.svg';
import passIcon from '../../assets/icons/lock.svg';
import uploadIcon from '../../assets/icons/uploads.svg';
import favIcon from '../../assets/icons/favourites.svg';
import sensitiveIcon from '../../assets/icons/shield.svg';
import logoutIcon from '../../assets/icons/logout.svg';
import userProfileIcon from '../../assets/icons/userProfile.svg';

const UserSidebarMenu = (props: any) => {
    const {onClick, userdata} = props;
    const {logOut, storedUserData} = useAuth();
    const {setAddAlert} = useAlert();

    //== Verification mail
    const sendVerificationMail = () => {
        apiClient.get(`${process.env.REACT_APP_GIFBUZ_API}${process.env.REACT_APP_END_POINT_SEND_VERIFICATION_EMAIL}/${userdata?.data?.email}`)
            .then((response: any) => {
                if (response?.status === 200) {
                    onClick();
                    setAddAlert({
                        alertType: 'default',
                        alertMessage: process.env.REACT_APP_MESSAGE_VERIFICATION_EMAIL_SENT
                    });
                } else {
                    setAddAlert({
                        alertType: 'error',
                        alertMessage: 'Activation mail sent failed. Something went wrong!'
                    })
                }
            })
            .catch(() => {
                setAddAlert({
                    alertType: 'error',
                    alertMessage: 'Activation mail sent failed. Something went wrong!'
                })
            });
    }

    return (
        <>
            <ul className={`${Classes.sidebarNavMenu} list-unstyled mt-lg-4`}>
                <hr className={'mt-0 d-block d-lg-none'}/>
                <li>
                    <NavLink
                        to={'/dashboard/account-settings'}
                        className={({isActive}) => isActive ? Classes.active : ''}
                        onClick={onClick}
                    >
                        <img
                            src={accIcon}
                            alt="Account Settings"
                            className={'img-fluid'}
                        /> Account Settings
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        className={({isActive}) => isActive ? Classes.active : ''}
                        to={'/dashboard/channel-settings'}
                        onClick={onClick}
                    >
                        <img
                            src={channelIcon}
                            alt="Account Settings"
                            className={'img-fluid'}
                        /> Channel Settings
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        className={({isActive}) => isActive ? Classes.active : ''}
                        to={'/dashboard/password-settings'}
                        onClick={onClick}
                    >
                        <img
                            src={passIcon}
                            alt="Account Settings"
                            className={'img-fluid'}
                        /> Password Settings
                    </NavLink>
                </li>

                <hr/>

                <li>
                    <NavLink
                        className={({isActive}) => isActive ? Classes.active : ''}
                        to={'/dashboard/uploads'}
                        onClick={onClick}
                    >
                        <img
                            src={uploadIcon}
                            alt="Account Settings"
                            className={'img-fluid'}
                        /> My Uploads
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        className={({isActive}) => isActive ? Classes.active : ''}
                        to={'/dashboard/favourites'}
                        onClick={onClick}
                    >
                        <img
                            src={favIcon}
                            alt="Account Settings"
                            className={'img-fluid'}
                        /> My Favorite
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        className={({isActive}) => isActive ? Classes.active : ''}
                        to={'/dashboard/sensitive-contents'}
                        onClick={onClick}
                    >
                        <img
                            src={sensitiveIcon}
                            alt="Account Settings"
                            className={'img-fluid'}
                        /> Sensitive Content
                    </NavLink>
                </li>

                <hr/>

                <li>
                    <NavLink
                        className={({isActive}) => isActive ? Classes.active : ''}
                        to={`/artist/${storedUserData?.userName}`}
                        onClick={onClick}
                    >
                        <img
                            src={userProfileIcon}
                            alt="Account Settings"
                            className={'img-fluid'}
                        /> User Profile
                    </NavLink>
                </li>

                <li>
                    <button
                        onClick={logOut}
                        className={'w-100'}
                    >
                        <img
                            src={logoutIcon}
                            alt="Account Settings"
                            className={'img-fluid'}
                        /> Logout
                    </button>
                </li>
            </ul>

            {(storedUserData?.emailVerified === false) && (
                <div className={`${Classes.emailVerifyWrap} text-center mt-3 mt-md-4`}>
                    <p>Your account is <strong>not verified.</strong> Please Click the button to verify your account</p>
                    <Button
                        bsPrefix={'g-btn'}
                        onClick={sendVerificationMail}
                    >
                        Verify
                    </Button>
                </div>
            )}
        </>
    );
};

export default UserSidebarMenu;